<template>
  <div class="main-view">
    <div class="section shadow filter__wrap">
      <el-form ref="elFormDom" inline :model="table.params" size="mini">
        <el-form-item label="日期:" prop="date_range">
          <el-date-picker
            v-model="table.params.date_range"
            type="daterange"
            :clearable="false"
            @change="onSearch"
            :value-format="'yyyy-MM-dd'"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button
            class="theneBtn"
            type="primary"
            icon="el-icon-search"
            @click="onSearch"
            >查询
          </el-button>
          <el-button @click="reset">重置</el-button>
        </el-form-item>
      </el-form>
      <div>
        <span>
          收益汇总:
          <span style="margin-left: 10px">累计收益: </span
          ><span style="color: red">￥{{ table.total_amount }}</span>
          <span style="margin-left: 10px">已结算收益: </span
          ><span style="color: red">￥{{ table.total_settle_amount }}</span>
          <span style="margin-left: 10px">待结算收益: </span
          ><span style="color: red">￥{{ table.total_await_amount }}</span>
        </span>
      </div>
    </div>

    <div class="curTableWrap" ref="main">
      <el-table
        :data="table.data"
        ref="tableDom"
        :height="height"
        border
        style="width: 100%"
        v-loading="table.loading"
        element-loading-text="拼命加载中"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0)"
        :header-cell-style="{ background: '#f5f5f5' }"
        class="chTable"
      >
        <el-table-column label="序号" type="index" key="0" width="60">
        </el-table-column>
        <el-table-column label="日期" prop="date"> </el-table-column>
        <el-table-column label="交易工单量/个" prop="num"> </el-table-column>
        <el-table-column label="工单金额" prop="amount">
          <template slot-scope="{ row }">
            <span>￥{{ row.amount }}</span>
          </template>
        </el-table-column>
        <el-table-column label="已结算收益" prop="settle_amount">
          <template slot-scope="{ row }">
            <span>￥{{ row.settle_amount }}</span>
          </template>
        </el-table-column>
        <el-table-column label="待结算收益" prop="await_amount">
          <template slot-scope="{ row }">
            <span>￥{{ row.await_amount }}</span>
          </template>
        </el-table-column>
        <el-table-column label="更新时间" prop="change_time"> </el-table-column>
        <el-table-column label="操作" prop="action" fixed="right" width="80">
          <template slot-scope="{ row }">
            <el-button type="text" icon="el-icon-view" @click="showDetail(row)"
              >查看</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination__wrap">
        <el-pagination
          background
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="table.params.page"
          :page-size="table.params.count"
          :total="table.total"
          :page-sizes="[10, 20, 50, 100, 150]"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        >
        </el-pagination>
      </div>
    </div>
    <detail ref="detail"></detail>
  </div>
</template>

<script>
import Detail from "./components/Detail.vue";
import { mixinTable } from "@/mixins/table.js";
export default {
  components: {
    Detail,
  },
  mixins: [mixinTable],
  data() {
    return {
      height: 0,
      table: {
        loading: false,
        params: {
          date_range: [],
          page: 1,
          count: 10,
        },
        data: [],
        total: 0,
        total_amount: 0,
        total_await_amount: 0,
        total_settle_amount: 0,
      },
    };
  },
  created() {
    const end = new Date();
    const start = new Date();
    start.setMonth(start.getMonth() - 1);

    const formatDate = (date) => {
      const y = date.getFullYear();
      const m = String(date.getMonth() + 1).padStart(2, "0");
      const d = String(date.getDate()).padStart(2, "0");
      return `${y}-${m}-${d}`;
    };

    this.table.params.date_range = [formatDate(start), formatDate(end)];
    this.getTable();
  },
  mounted() {
    this.height = this.$refs.main.offsetHeight || 500;
  },
  methods: {
    getTable() {
      let _params = { ...this.table.params };
      if (
        this.table.params.date_range &&
        this.table.params.date_range.length > 0
      ) {
        _params.start_time = this.table.params.date_range[0];
        _params.end_time = this.table.params.date_range[1];
      } else {
        _params.start_time = "";
        _params.end_time = "";
      }
      delete _params.date_range;
      this.table.loading = true;
      this.$http
        .get("/agency/income/list", { params: _params })
        .then((res) => {
          if (res.code === 1) {
            this.table.loading = false;
            this.table.data = res.data.list;
            this.table.total = res.data.total;
            this.table.total_amount = res.data.total_amount;
            this.table.total_await_amount = res.data.total_await_amount;
            this.table.total_settle_amount = res.data.total_settle_amount;
            this.$nextTick(() => {
              // 	对 Table 进行重新布局。当 Table 或其祖先元素由隐藏切换为显示时，可能需要调用此方法
              if (this.$refs.tableDom && this.$refs.tableDom.doLayout) {
                this.$refs.tableDom.doLayout();
              }
            });
          }
        })
        .finally(() => {
          this.table.loading = false;
        });
    },
    // 查看
    showDetail(row) {
      let dom = this.$refs.detail;
      dom.toggle(true);
      let obj = {
        ...row,
      };
      dom.getDetail(obj);
      dom = null;
    },
  },
};
</script>

<style scoped>
.curTableWrap {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 0 24px;
  background: #fff;
  flex: 1;
  overflow-y: scroll;
}
.pagination__wrap {
  margin: 10px 0;
  text-align: right;
  /* padding-right: 40px; */
}
</style>